<template>
  <div>
    <!-- DYNAMIC MODAL -->
    <ModalDynamic/>

    <!-- CART CHANGED MODAL -->
    <Modal :open="isOpen(CART_CHANGED_MODAL)"
           :closable="true"
           data-test-id="modal-cartchanged-container"
           @close="toggle(CART_CHANGED_MODAL, false)">
      <ModalCartChanged/>
    </Modal>

    <!-- ERROR MODAL -->
    <Modal :open="isOpen(ERROR_MODAL)"
           :closable="true"
           data-test-id="modal-error-container"
           @close="toggle(ERROR_MODAL, false)">
      <ModalError/>
    </Modal>

    <!-- Login / Signup Modals -->
    <Modal
        data-test-id="modal-login"
        :open="isOpen(LOGIN_MODAL)"
        @close="toggle(LOGIN_MODAL, false)"
    >
      <div class="modal__login">
        <LoginForm/>
      </div>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { CART_CHANGED_MODAL, ERROR_MODAL, LOGIN_MODAL } from '@/types/Modals'
import LoginForm from '@/components/Forms/LoginForm/LoginForm.vue'
import Modal from '@/components/Modals/Modal.vue'
import ModalDynamic from '@/components/Modals/ModalDynamic.vue'
import ModalCartChanged from '@/components/Modals/ModalCartChanged.vue'
import ModalError from '@/components/Modals/ModalError.vue'
import { useModalsStore } from "@/stores/useModalsStore"

const { isOpen, toggle } = useModalsStore()
</script>

<style scoped lang="scss">
@import "@/assets/css/mixins/breakpoints-up.scss";

.modal {
  &__login {
    width: 100%;
    margin-top: 1rem;

    @include lg-up {
      width: 30rem;
    }
  }
}
</style>
